import { useEffect, useState } from 'react';

/** Текущее время performance.now(), обновляемое каждым кадром (для таймеров и индикаторов). 0 — до первого кадра. */
export function useNow(active = true): number {
  const [now, setNow] = useState(0);
  useEffect(() => {
    if (!active) return;
    let raf = 0;
    const tick = () => {
      setNow(performance.now());
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [active]);
  return now;
}

/** Секунд до серверного дедлайна с поправкой на часы клиента. */
export function secondsLeft(deadline: number, clockOffset: number, nowMs = Date.now()): number {
  return Math.max(0, (deadline - (nowMs + clockOffset)) / 1000);
}

/** Настенное время Date.now(), обновляемое каждым кадром (для обратных отсчётов до серверных дедлайнов). */
export function useWallClock(): number {
  const [now, setNow] = useState(0);
  useEffect(() => {
    let raf = 0;
    const tick = () => {
      setNow(Date.now());
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, []);
  return now;
}
